import { CAMPS } from "utils/constants";
import { createExporter } from "utils/createExporter";

export const CampExporter = createExporter(`${CAMPS}.xlsx`,
   [
    { key: "nameBg", label: "име на български" },
    { key: "nameEn", label: "име на английски" },
    { key: "registrationStart", label: "начало на регистрация" },
    { key: "registrationEnd", label: "край на регистрация" },
    { key: "startDate", label: "начална дата" },
    { key: "endDate", label: "крайна дата" },
  ],
    (record) => ({
        ...record
    })
);